


export function InputRadio(props) {
    const { options, selectedValue, onChange, name } = props;
  
  return (
    <div className={`radio ${name === 'period' ? 'radio__period' : ''}`}>
      {options.map(option => (
        <label key={option.value} className='radio__label font20Norm' >
          <input type="radio" value={option.value} checked={selectedValue === option.value} className='radio__checkbox' onChange={onChange} name={name} id={option.value} />
          <span className="visible-checkbox item__link"></span>
          {option.label}
        </label>
      ))}
    </div>
  );
  }